import axios from 'axios'

export const annualsurvey = axios.create({
  baseURL: '/oceans-vehicle-verify',
  // 斑马数据测试环境查询需要15秒左右时间，所以暂时先配置成20秒
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true
})



// WEBPACK FOOTER //
// ./src/libs/ajax/annualsurvey.js